import { Modal } from "../../utils/fw"
import { isMember } from "../utils"
import assets, { getDay } from "../assets.js"
import WhatsOnNow from "./atrium/WhatsOnNow"
import TimedPopups from "./atrium/TimedPopups"
import { useState } from "preact/hooks"

const NotAMemberModal = () => <Modal 
	dismissHTML="X"
	dismissStyle={{top: 4, color:"white", fontSize: "21px"}}
>
	<div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
		<h1 style="font-size: 28px; margin: 0;">Content locked</h1>
		<p style="font-size: 16px;">You need to be a member to access that room.</p>
	</div>
</Modal>

export default function () {
	const day = getDay()

	return {
		background: day === 3 ? assets.lobby.od : assets.lobby.df,
		default: true,
		links: [
			// {
			// 	label: "What's on now",
			// 	left: "25%",
			// 	top: "40.2%",
			// 	width: "14.1%",
			// 	height: "16.7%",
			// 	modalOverrides: {
			// 		style: {
			// 			width: "1000px",
			// 			background: "#ffffff1f",
			// 			backdropFilter: "blur(4px)",
			// 			border: "1px solid #ffffff4d"
			// 		},
			// 		dismissHTML: "X",
			// 	},
			// 	modal: <WhatsOnNow />
			// },
			{
				label: "Congress Highlights",
				left: "25%",
				top: "40.2%",
				width: "14.1%",
				height: "16.7%",
				modalOverrides: {
					dismissHTML: "X",
				},
				modal: <>
					<iframe src="https://player.vimeo.com/video/1126133412?autoplay=1&loop=1&muted=0" allow="autoplay" style={{
                        border: 0,
                        borderRadius: "16px",
                        width: "66em",
                        marginTop: "22px",
                        aspectRatio: "16/9"
                    }} />
				</>
			},
			{
				height: "18%",
				href: !isMember ? undefined : "/expo-hall",
				label: "Expo Hall",
				left: "26.3%",
				top: "17%",
				width: "12.6%",
			},
			{
				height: "18%",
				href: !isMember ? undefined : "/exploration-zone",
				label: "Exploration Zone",
				left: "26.3%",
				top: "56.7%",
				width: "12.6%",
				modal: !isMember ? <NotAMemberModal /> : undefined
			},
			{
				height: "13.9%",
				isExternal: true,
				label: "FAQs",
				left: "23.2%",
				onClick() {
					window.open("https://events.securityforum.org/isfcongress2025/faqsvirtual")
				},
				top: "77.1%",
				width: "5.4%",
				modal: !isMember ? <NotAMemberModal /> : undefined
			},
			{
				height: "18.5%",
				label: "Information/Help Desk",
				onClick: () => {smartsupp('chat:open')},
				left: "29.8%",
				top: "75.6%",
				width: "17.4%",
			},
			{
				href: "/on-demand",
				label: "On Demand",
				...( day < 3 ?
					{
						left: "57.5%",
						top: "14%",
						width: "11.9%",
						height: "23.2%"
					} : {
						height: "23.2%",
						left: "57.5%",
						top: "52.6%",
						width: "11.9%",
					}
				)
			},
			...[
				{
					height: "23.2%",
					href: day <= 2 ? "/auditorium-foyer" : undefined,
					label: "Main Auditorium",
					left: "57.5%",
					top: "52.6%",
					width: "11.9%",
					modalOverrides: {
						dismissHTML: "X"
					},                 
					modal: day > 2 ? <div className="onDemandPopup" style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; color: white;">
							{ assets.lobby.timedPopups[assets.lobby.timedPopups.length - 1].text.map(row => <p>{row}</p>) }
							<a className="cta" href="/on-demand">Check out our On Demand rooms!</a>
					</div> : undefined
				}
			].filter(() => day < 3),
			// {
			// 	height: "17.2%",
			// 	label: "Leaderboard TV",
			// 	left: "71.5%",
			// 	top: "48.6%",
			// 	width: "13.9%",
			// 	onClick: () => document.getElementById("Leaderboard")?.click()
			// }
			{
				height: "17.2%",
				label: "ISF 2026",
				left: "71.5%",
				top: "48.6%",
				width: "13.9%",
				modalOverrides: {
					dismissHTML: "X"
				},
				modal: <>
					<iframe src="https://player.vimeo.com/video/1112295170?autoplay=1&loop=1&muted=0" allow="autoplay" style={{
                        border: 0,
                        borderRadius: "16px",
                        width: "66em",
                        marginTop: "22px",
                        aspectRatio: "16/9"
                    }} />
				</>
			}
		],
		showNavbar: false,
		extras: <TimedPopups days={assets.lobby.timedPopups}/>,
		name: "atrium",
	}
}
